import moment from 'moment';

export const shortDateTime = (datetime) => moment(datetime).format('MMM D - h:mm a');

export default { shortDateTime };
